Date.prototype.getWeek = function () {
  var that = new Date(this.getTime());
  that.setHours(0, 0, 0, 0);

  that.setDate(that.getDate() + 3 - (that.getDay() + 6) % 7);

  var week1 = new Date(that.getFullYear(), 0, 4);
  return 1 + Math.round(((that.getTime() - week1.getTime()) / 86400000
    - 3 + (week1.getDay() + 6) % 7) / 7);
};

Date.prototype.getWeekYear = function () {
  var that = new Date(this.getTime());
  that.setDate(that.getDate() + 3 - (that.getDay() + 6) % 7);
  return that.getFullYear();
};

Date.prototype.isBetween = function ( dateFrom, dateTo, comparedBy ) {
  if ( typeof comparedBy === 'undefined' ) {
    comparedBy = null;
  }

  if ( comparedBy === null ) {
    return (+dateFrom <= +this && +this <= +dateTo);
  }
  else {
    var that = this;
    that.resetTo(comparedBy, true);
    dateFrom.resetTo(comparedBy, true);
    dateTo.resetTo(comparedBy, true);
    return (+dateFrom <= +that && +that <= +dateTo);
  }
};

Date.prototype.isSame = function ( date, comparedBy ) {

  if ( typeof comparedBy === 'undefined' ) {
    comparedBy = null;
  }

  if ( comparedBy === null ) {
    return (+this === +date);
  }
  else {
    var that = this;

    that.resetTo(comparedBy, true);
    date.resetTo(comparedBy, true);

    return (+that === +date);
  }

};

Date.prototype.isBefore = function ( date, comparedBy ) {
  if ( typeof comparedBy === 'undefined' ) {
    comparedBy = null;
  }

  if ( comparedBy === null ) {
    return (+this < +date);
  }
  else {
    var that = this;
    that.resetTo(comparedBy, true);
    date.resetTo(comparedBy, true);

    return (+that < +date);
  }
};

Date.prototype.isAfter = function ( date, comparedBy ) {
  if ( typeof comparedBy === 'undefined' ) {
    comparedBy = null;
  }

  if ( comparedBy === null ) {
    return (+this > +date);
  }
  else {
    var that = this;
    that.resetTo(comparedBy, true);
    date.resetTo(comparedBy, true);

    return (+that > +date);
  }

};

Date.prototype.resetTo = function ( reseter, upset = false ) {
  if ( typeof upset === 'undefined' ) {
    upset = false;
  }

  if ( upset ) {
    var set = [ 'year', 'month', 'day', 'hour', 'minute', 'second' ],
      idx = set.indexOf(reseter);
    reseter = set[ idx + 1 ];
  }

  this.setMilliseconds(0);

  switch ( reseter ) {

    case 'month' :
      this.setMonth(1);

    case 'day' :
      this.setDate(1);

    case 'hour' :
      this.setHours(1);

    case 'minute' :
      this.setMinutes(0);

    case 'second':
      this.setSeconds(0);
  }
};


/**
 * Vue Filter for Date formatting
 *
 **/
export default {

  install( Vue, options ) {

    var weekDays = [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
      weekDaysShort = [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ];
    // monthsShort = [ 'Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

    Vue.filter('dateFormat', function ( value, format ) {

      var date = new Date(value),
        result = '',
        escape = false;
      for ( let i = 0; i < format.length; i++ ) {
        /** ToDo
         * [ ] other format possibilities
         * [ ] escape characters for added Text
         */

        switch ( format[ i ] ) {
          case '[':
            escape = true;
            break;
          case ']':
            escape = false;
            break;
          /** Time */
          case 'a' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += (date.getHours() > 12 ? 'pm' : 'am');
            }
            break;
          case 'A' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += (date.getHours() > 12 ? 'pm' : 'am').toString().toUpperCase();
            }
            break;

          /** Minute */
          case 'i' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getMinutes().toString().padStart(2, 0);
            }
            break;
          // case 'I' : if( ! escape  {esult += date.getMinutes(); } break;

          /** Hour */
          case 'g' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getHours();
            }
            break;
          case 'G' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getHours();
            }
            break;
          case 'h' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getHours();
            }
            break;
          case 'H' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getHours().toString().padStart(2, 0);
            }
            break;

          /** Day */
          case 'd' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getDate();
            }
            break;
          case 'j' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getDate().toString().padStart(2, 0);
            }
            break;

          case 'l' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += weekDays[ date.getDay() ];
            }
            break;
          case 'D' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += weekDaysShort[ date.getDay() ];
            }
            break;

          /** Week */
          case 'W' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getWeek();
            }
            break;

          /** Month */
          case 'F' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.toLocaleString('de-de', {month: 'long'});
            }
            break;
          case 'n' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += (date.getMonth() + 1);
            }
            break;
          case 'm' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += (date.getMonth() + 1).toString().padStart(2, 0);
            }
            break;
          case 'M' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.toLocaleString('de-de', {month: 'short'});
            }
            break; // monthsShort[ date.getMonth() ]; } break;

          /** Year */
          case 'Y' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getFullYear();
            }
            break;
          case 'y' :
            if ( escape ) {
              result += format[ i ];
            }
            else {
              result += date.getFullYear().toString().slice(2);
            }
            break;

          default :
            result = result + format[ i ];
        }
      }

      return result;
    });

    Vue.filter('toMiliSeconds', function ( value ) {
      return (1000 * value);
    });
  }

};



// WEBPACK FOOTER //
// ./src/utils/Date.js